import React from "react";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import formatMoney from "lib/formatMoney";

export default function LTVQuoteTable({
  loanQuoteData,
  propertyValue,
  current5yrTreasury,
}) {
  const theme = useTheme();

  if (!loanQuoteData?.LTVObj) {
    return null;
  }

  // Sort LTV values from highest to lowest
  const sortedLTVKeys = Object.keys(loanQuoteData.LTVObj).sort(
    (a, b) => parseInt(b) - parseInt(a)
  );

  // Define rows for the table
  const rows = [
    {
      name: "Credit spread",
      getValue: (ltv) => {
        const data = loanQuoteData.LTVObj[ltv];
        return `+${data.creditSpread?.toFixed(2)}%`;
      },
    },
    {
      name: "DSCR requirement",
      getValue: (ltv) => {
        const data = loanQuoteData.LTVObj[ltv];
        return data.DSCRCutoff?.toFixed(2) || "N/A";
      },
    },
    {
      name: "Min credit score",
      getValue: (ltv) => {
        const data = loanQuoteData.LTVObj[ltv];
        return data.creditScoreCutoff || "N/A";
      },
    },
  ];

  // const handleLTVSelect = (ltv) => {
  //   // Update the LTV value in the form
  //   const updatedAnswers = answers.slice(0);
  //   const toUpdateAnswer = updatedAnswers.find(
  //     (answer) => answer?.q_title === "Loan to value (LTV)"
  //   );

  //   if (toUpdateAnswer) {
  //     toUpdateAnswer.a_string = ltv;
  //     setAnswers(updatedAnswers);
  //   }
  // };

  return (
    <TableContainer
      component={Paper}
      sx={{
        mt: 2,
        mb: 2,
        maxWidth: "100%",
        overflowX: "auto",
      }}
    >
      <Table size="small" aria-label="LTV quote table">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                backgroundColor: theme.palette.primary.main,
                fontWeight: 600,
                color: "white !important",
                minWidth: 150,
                position: "sticky",
                left: 0,
                zIndex: 0,
              }}
            >
              LTV
            </TableCell>
            {sortedLTVKeys.map((ltv) => (
              <TableCell
                key={ltv}
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  fontWeight: 600,
                  color: "white !important",
                  textAlign: "center",
                  minWidth: 120,
                }}
              >
                {ltv}%
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{
                  backgroundColor: theme.palette.grey[50],
                  fontWeight: 600,
                  position: "sticky",
                  left: 0,
                  zIndex: 0,
                }}
              >
                {row.name}
              </TableCell>
              {sortedLTVKeys.map((ltv) => (
                <TableCell
                  key={ltv}
                  sx={{
                    textAlign: "center",
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  {row.getValue(ltv)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
